'use strict';

import { CONST, addParamsToUrl, getParamsFromUrl } from 'app_vodafone_ziggo/util/util';
import { handleTransition } from 'Util/transitions.js';

export default class VZConfiguratorLogin extends HTMLElement {
    constructor() {
        super();
        this.boundHandleRadioChange = this.handleRadioChange.bind(this);
    }

    connectedCallback() {
        this.setupRadioButtons();
        this.infoCard = this.querySelector('.js-configurator-login-info');
        this.loginButton = this.querySelector('.js-configurator-login-info a');
        this.productCard = this.closest('.js-product-card') || this.closest('.js-tc-product-card');
        this.configuratorLoginInput = document.querySelector('input[name="configurator-login"]:checked');

        if (this.productCard) this.productCard.setAttribute('configurator-login-answer', this.configuratorLoginInput?.value);

        // Set initial state based on checked radio
        const checkedRadio = this.querySelector('.js-question-content-toggle:checked');
        if (checkedRadio && checkedRadio.value === 'yes') {
            this.infoCard?.classList.remove(CONST.classes.dNone);
        }

        // Handle SSO login button click
        this.loginButton.addEventListener('click', this.handleLoginClick.bind(this));
    }

    disconnectedCallback() {
        const radioButtons = this.querySelectorAll('.js-question-content-toggle');
        radioButtons.forEach((radio) => {
            radio.removeEventListener('change', this.boundHandleRadioChange);
        });
    }

    setupRadioButtons() {
        const radioButtons = this.querySelectorAll('.js-question-content-toggle');
        radioButtons.forEach((radio) => {
            radio.addEventListener('change', this.boundHandleRadioChange);
        });
    }

    handleRadioChange(event) {
        const value = event.target.value;

        // Show/hide info card based on selection
        if (this.infoCard) {
            if (this.productCard) this.productCard.setAttribute('configurator-login-answer', value);

            handleTransition(() => {
                if (value === 'yes') {
                    this.infoCard.classList.remove(CONST.classes.dNone);
                } else {
                    this.infoCard.classList.add(CONST.classes.dNone);
                }
            });
        }
    }

    handleLoginClick(event) {
        const urlElement = this.productCard?.getAttribute('data-share-configurator-link');
        if (!urlElement) return;
        event.preventDefault();
        try {
            const configuratorParams = getParamsFromUrl(urlElement);
            const updatedURL = addParamsToUrl(this.loginButton.href, configuratorParams);
            window.location.replace(updatedURL);
        } catch {
            window.location.replace(this.loginButton.href);
        }
    }
}

if (!window.customElements.get('vz-configurator-login')) {
    window.customElements.define('vz-configurator-login', VZConfiguratorLogin);
}
